import React from 'react'

import { Label } from '@/atoms/Typography'

import Controller from './Controller'

import {
  StyledFieldset,
  StyledFieldsetTitle,
  StyledFieldsetContent
} from './styles'

const Fieldset = ({
  title = null,
  fields = null
}) => {
  return (
    <StyledFieldset>
      {
        title &&
        <StyledFieldsetTitle>
          <Label as="strong" typo="h5" uppercase $title bold>{title}</Label>
        </StyledFieldsetTitle>
      }

      {
        fields &&
        !!fields.length &&
        <StyledFieldsetContent>
          {
            fields.map((field, idx) => <Controller key={idx} {...field} />)
          }
        </StyledFieldsetContent>

      }
    </StyledFieldset>
  )
}

export default Fieldset
